import { Col, Divider, Row } from "antd";
import React from "react";
import FirstRow from "../FirstRow/FirstRow";
import SecondRow from "../SecondRow/SecondRow";
import SideNav from "../SideNav/SideNav";

// Desktop menu
export const DesktopMenu = (props) => {
  const {
    tnavfirst,
    tnavsecond,
    tnavthird,
    bnavfirst,
    bnavsecond,
    bnavthird,
    rightmenu,
    datalinks,
    mcontact,
  } = props;

  const openCookieSettings = () => {
    document.querySelector(".cboverlay")?.classList.toggle("visible");
  };
  return (
    <div className="megamenu__wrapper">
      <div className="megamenu__container">
        <Row gutter={64}>
          <Col flex={3}>
            <Row gutter={32} style={{ width: "100%" }}>
              <FirstRow
                tnavfirst={tnavfirst}
                tnavsecond={tnavsecond}
                tnavthird={tnavthird}
              />
            </Row>

            <Row gutter={32} style={{ width: "100%" }}>
              <SecondRow
                bnavfirst={bnavfirst}
                bnavsecond={bnavsecond}
                bnavthird={bnavthird}
              />
            </Row>
          </Col>
          <Col xs={24} md={1} style={{ textAlign: "center" }}>
            <Divider
              type="vertical"
              style={{ height: "100%", backgroundColor: "#F1f1f1" }}
            />
          </Col>

          <Col style={{ display: "flex" }}>
            <SideNav mcontact={mcontact} rightmenu={rightmenu} />
          </Col>
        </Row>

        <Row gutter={64}>
          <Col flex={1}>
            <div className="megamenu__footer">
              {datalinks && (
                <ul>
                  {datalinks.map((item, index, array) =>
                    index === array.length - 1 ? (
                      <li>
                        <a onClick={openCookieSettings} href="#">
                          {item.title}
                        </a>
                      </li>
                    ) : (
                      <li>
                        <a href={item.url}>{item.title}</a>
                      </li>
                    ),
                  )}
                </ul>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
